// fastest way: check all shields for isMatrix one time only and add it to isMatrixShield
export default (layouts) => {
  const result = {};

  for (const layoutUid in layouts) {
    const { groups } = layouts[layoutUid];
    for (const groupUid in groups) {
      const { shields } = groups[groupUid];
      for (const shieldId in shields) {
        result[shieldId] = shields[shieldId].isMatrix;
      }
    }
  }

  return result;
};
